import styled from '@emotion/styled'

export const BottomActionsContainer = styled.div({
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    margin: "0.625rem 0px 0.625rem auto",
});